// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"2f88042f","232":"b34e53cd"}[chunkId] + ".css";
};